import { createSelector } from '@ngrx/store';
import { selectAuthState } from './auth.selectors';

export const selectSignUpState = createSelector(
  selectAuthState,
  (state) => state.signUp,
);

export const getSignUpForm = createSelector(
  selectSignUpState,
  (state) => state.form,
);
